function Israel({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1402)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
        <path d="M22.0246 12.5217H18.0082L16 9.04346L13.992 12.5217H9.97546L11.9838 16L9.97546 19.4782H13.992L16 22.9565L18.0082 19.4782H22.0246L20.0162 16L22.0246 12.5217ZM18.4672 16L17.2337 18.1367H14.7665L13.5328 16L14.7665 13.8632H17.2337L18.4672 16ZM16 11.7264L16.4592 12.5216H15.541L16 11.7264ZM12.2992 13.8632H13.2174L12.7583 14.6585L12.2992 13.8632ZM12.2992 18.1367L12.7583 17.3415L13.2175 18.1367H12.2992ZM16 20.2735L15.541 19.4782H16.4592L16 20.2735ZM19.7009 18.1367H18.7827L19.2418 17.3415L19.7009 18.1367ZM18.7827 13.8632H19.7009L19.2418 14.6585L18.7827 13.8632Z" fill="#0052B4"/>
        <path d="M25.9598 3.47803H6.0402C4.58001 4.64103 3.32776 6.05365 2.34839 7.65196H29.6516C28.6722 6.05371 27.4199 4.64103 25.9598 3.47803V3.47803Z" fill="#0052B4"/>
        <path d="M6.0402 28.5216H25.9598C27.4199 27.3586 28.6722 25.946 29.6516 24.3477H2.34839C3.32783 25.9459 4.58008 27.3586 6.0402 28.5216V28.5216Z" fill="#0052B4"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default Israel;
